import * as React from "react";
import IDatePickerWidgetPropsType from "./IDatePickerWidgetPropsType";
import "../../../assets/sass/widgets/datePickerWidget.scss";
import Calendar from "react-calendar";
// import previousIcon from "../../../assets/images/chevron-left-1.svg";
// import nextIcon from "../../../assets/images/chevron-right-1.svg";
import MaskedInput from "react-text-mask";
import Label from "../../components/Label";
import ErrorMessage from "../../components/ErrorMessage";
import { dateFormatter, handleEnter, checkForReadOnly, checkForPriceChanges } from "../../utils/utils";
import onClickOutside from "react-onclickoutside";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import * as globalErrorActionCreators from "../../globalStore/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { validationCheck , validateEmailPDFCanBeSent} from "../../utils/validation";
import { valueResolver, getPriceCheckDetails, imagePathurl, dateTimeFormatter } from "../../utils/utils";
import { fetchAPI } from "../../utils/service";
import endpoints, { endpointTypes } from "../../service";
import ReactGA from "react-ga";
// import 'react-calendar/dist/Calendar.css';
interface IDatePickerWidgetStateType {
    openCalendar: any;
    date: any;
    dateValue: any;
    todaysDate: any;
    error: any;
    previousValue: any;
}
/**
 * @class DatePicker
 * @description
 * This component uses “react-calendar” library to display the calender on the UI , the customization enabling the validation for the dates and the updating the selected value of the form showing
 * the errors are handles in this component
 * @category Widgets
 */
class DatePickerWidget extends React.Component<IDatePickerWidgetPropsType, IDatePickerWidgetStateType> {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            dateValue: this.props.value || "",
            previousValue: this.props.value || "",
            todaysDate: new Date(),
            openCalendar: false,
            error: { error: false, errorMessage: [] },
        };
        this.onChange = this.onChange.bind(this);
        this.dateFormatter = this.dateFormatter.bind(this);
        this.getFullDayString = this.getFullDayString.bind(this);
        this.calendarToggle = this.calendarToggle.bind(this);
        this.inputBoxChange = this.inputBoxChange.bind(this);
        this.blurCheck = this.blurCheck.bind(this);
        this.customDateFormatter = this.customDateFormatter.bind(this);
        this.validateToDate = this.validateToDate.bind(this);
        this.validateFromDate = this.validateFromDate.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this.changeDateValue();
        if(this.state.dateValue){
            this.checkDateEmailPDFValidation(this.state.dateValue,"mount");
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.schema.const.family !== this.props.schema.const.family) {
            this.setState({
                error: { error: false, errorMessage: [] },
            });
        }
        // if (prevProps.warrantyInfo !== this.props.warrantyInfo) {
        //     this.setState({
        //         error: { error: false, errorMessage: [] },
        //     });
        // }
    }

    changeDateValue() {
        if (this.state.dateValue.length === 0) {
            this.props.onChange(this.state.dateValue);
        } else {
            this.props.onChange(dateFormatter(this.state.dateValue));
        }
        this.props.getValues && this.props.getValues(this.state);
        
    }

    handleClickOutside(evt) {
        this.setState({
            openCalendar: false,
        });
    }

    async onChange(date) {
        const { errorSchema, schema, isSubmittedForm, id } = this.props;
        const { family, fieldName, priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        if (
            dateFormatter(date) !== this.state.previousValue &&
            priceCheck &&
            priceCheck.length > 0 &&
            checkForPriceChanges(schema.const, isSubmittedForm)
        ) {
            const x = await this.checkForPrice(dateFormatter(date));
            if (x && x.data && x.data.isPriceChanged) {
                this.setState(
                    {
                        dateValue: this.state.previousValue,
                        openCalendar: !this.state.openCalendar,
                        error: { error: true, errorMessage: [priceCheck[0].message] },
                    },
                    () => {
                        this.props.onChange(this.state.dateValue);
                    }
                );
            } else {
                this.setState(
                    {
                        dateValue: dateFormatter(date),
                        openCalendar: !this.state.openCalendar,
                    },
                    () => {
                        this.props.onChange(this.state.dateValue);
                    }
                );
            }
        } else {
            this.setState(
                {
                    date,
                    dateValue: date,
                    openCalendar: !this.state.openCalendar,
                    error: this.adminPreviousDateCheck(date)
                        ? { error: false, errorMessage: [] }
                        : validationCheck(date, fieldName, family, errorSchema),
                },
                () => this.changeDateValue()
            );
        }
        this.checkDateEmailPDFValidation(date,"onchange");
    
    }

async checkDateEmailPDFValidation(date,type){
    if( new Date(date) <= new Date()){
        let apiResponse =  await validateEmailPDFCanBeSent(this.props, date, "",type);
        if(apiResponse && !apiResponse.canGenerateReport){
        let msg = apiResponse.emailMessage.split(":");
        this.setState(
            {
                date,
                dateValue: date,
                openCalendar: false,
                error: 
                    { error: true, errorMessage: [`${msg[0]}`] }
                
            },
            () => this.changeDateValue()
         )
    }
}
}

    dateFormatter(date) {
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEPT", "OCT", "NOV", "DEC"];
        return (
            this.getFullDayString(new Date(date).toDateString().split(" ")[0]) +
            ", " +
            months[new Date(date).getMonth()] +
            ". " +
            new Date(date).getDate()
        );
    }

    getFullDayString(day) {
        switch (day.toLowerCase()) {
            case "sun":
                return "SUNDAY";
            case "mon":
                return "MONDAY";
            case "tue":
                return "TUESDAY";
            case "wed":
                return "WEDNESDAY";
            case "thu":
                return "THURSDAY";
            case "fri":
                return "FRIDAY";
            default:
                return "SATURDAY";
        }
    }

    adminPreviousDateCheck = (date) => {
        return this.props.userInfo.isAdmin && new Date(date) < new Date();
    };

   async calendarToggle() {
        const { errorSchema, schema, id } = this.props;
        const { family, fieldName } = getPriceCheckDetails(errorSchema, schema, id);
        this.setState(
            {
                openCalendar: !this.state.openCalendar,
                dateValue: this.state.date || this.state.todaysDate,
                error: this.adminPreviousDateCheck(this.state.dateValue || this.state.date || this.state.todaysDate)
                    ? { error: false, errorMessage: [] }
                    : validationCheck(this.state.date || this.state.todaysDate, fieldName, family, errorSchema),
            },
            () => {
                this.props.onChange(dateFormatter(this.state.dateValue));
                this.props.getValues && this.props.getValues(this.state);
            }
        );
    }

   async inputBoxChange(e) {
        const { errorSchema, schema, id } = this.props;
        // const id = this.props.id.split("_");
        // const fieldName = this.props.id.split("_")[id.length - 1];
        // const { family } = this.props.schema.const;
        const inputValue = e.target.value;
        const { family, fieldName } = getPriceCheckDetails(errorSchema, schema, id);
        if (e.target.value === "") {
            this.setState({
                date: "",
                dateValue: "",
                openCalendar: false,
                error: validationCheck("", fieldName, family, errorSchema),
            });
            return;
        }
        if (!isNaN(new Date(e.target.value).getTime())) {
            this.setState(
                {
                    date: e.target.value,
                    dateValue: e.target.value,
                    openCalendar: false,
                    error: this.adminPreviousDateCheck(e.target.value)
                        ? { error: false, errorMessage: [] }
                        : validationCheck(e.target.value, fieldName, family, errorSchema),
                },
                () => {
                    this.props.onChange(inputValue);
                }
            );
        }
        this.checkDateEmailPDFValidation(e.target.value,"onchange");
    }

    adminChecks = () => {
        const { schema, userInfo } = this.props;
        return userInfo.isAdmin && schema.const.adminSettings ? schema.const.adminSettings.fromDate === "" : false;
    };

    validateFromDate(date) {
        const { schema } = this.props;
        const today = new Date();
        const calc = today.setDate(today.getDate() - parseInt(schema.const.fromDate) - 1);
        const calc1 = date.setDate(date.getDate());

        return this.adminChecks() ? true : calc1 >= calc;
    }

    validateToDate(date) {
        const { schema } = this.props;
        const today = new Date();
        const calc = today.setDate(today.getDate() + parseInt(schema.const.toDate));
        const calc1 = date.setDate(date.getDate());
        return this.adminChecks() ? true : calc1 <= calc;
    }

    checkForPrice = (e) => {
        this.props.dynamicFormActions.apiRunningStatus(true);
        const { errorSchema, schema, id } = this.props;
        const { fieldName, priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        let reqObject;
        for (const i in JSON.parse(priceCheck[0].value)) {
            reqObject = {
                ...reqObject,
                [i]: valueResolver(this.props.warrantyData, JSON.parse(priceCheck[0].value)[i].trim()),
                [fieldName]: e,
            };
        }
        const requestobject = {
            data: reqObject,
            warrantyId: this.props.warrantyId,
        };
        const successCallBackEditCheck = async () => {
            const formLayoutRoute = endpoints[endpointTypes.FORMLAYOUT];
            const editableCheckEndpoint = formLayoutRoute.endpoints.checkEditable(requestobject);
            try {
                const response = await fetchAPI(editableCheckEndpoint);
                this.props.dynamicFormActions.apiRunningStatus(false);
                return response;
            } catch (err) {
                this.setState(
                    {
                        dateValue: this.state.previousValue,
                        error: { error: false, errorMessage: [] },
                    },
                    () => {
                        this.props.globalErrorActions.showGlobalError(err);
                        this.props.dynamicFormActions.apiRunningStatus(false);
                        this.props.dynamicFormActions.submitClicked(false);
                        this.props.onChange(this.state.previousValue);
                    }
                );
            }
        };
        return successCallBackEditCheck();
    };

    async blurCheck(e) {
        const { schema, isSubmittedForm, errorSchema, id } = this.props;
        const userInput = e.target.value;
        const { family, fieldName, priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        e.stopPropagation();
        // check for valid date input
        this.checkDateEmailPDFValidation(userInput,"onblur");
        if (!isNaN(new Date(e.target.value).getTime()) || isSubmittedForm) {
            const validationError = validationCheck(userInput, fieldName, family, errorSchema);
            if (validationError && validationError.error) {
                this.setState({
                    error: this.adminPreviousDateCheck(e.target.value)
                        ? { error: false, errorMessage: [] }
                        : validationCheck(this.state.dateValue, fieldName, family, errorSchema),
                });
            }
            // check if fromDate is set in the backend response
            if (schema.const.fromDate) {
                // check if user input date is more that fromDate and less than toDate
                if (this.validateFromDate(new Date(e.target.value))) {
                    // Validate price dependency here
                    if (
                        e.target.value &&
                        e.target.value !== this.state.previousValue &&
                        priceCheck &&
                        priceCheck.length > 0 &&
                        checkForPriceChanges(schema.const, isSubmittedForm)
                    ) {
                        const x = await this.checkForPrice(dateFormatter(e.target.value));
                        const {
                            warrantyInfo,
                            warrantyId,
                            waiverReceived,
                            dynamicFormActions: { submitWarranty },
                        } = this.props;
                        if (x && x.data && x.data.isPriceChanged) {
                            this.props.dynamicFormActions.submitClicked(false);
                            this.props.dynamicFormActions.apiRunningStatus(false);
                            this.props.dynamicFormActions.navigationClickDetails({});
                            this.setState(
                                {
                                    dateValue: this.state.previousValue,
                                    error: { error: true, errorMessage: [priceCheck[0].message] },
                                },
                                () => {
                                    this.props.onChange(this.state.previousValue);
                                }
                            );
                        } else if (x && x.data && !x.data.isPriceChanged && this.props.isSubmitClicked) {
                            // submit form only if there is no price change
                            const handleSubmitError = (data) => {
                                const validationMessage = (data.errors && data.errors.validationMessage) || "";
                                if (validationMessage) {
                                    const payload = {
                                        errors: data.errors,
                                    };
                                    this.props.globalErrorActions.showGlobalError({ Message: validationMessage });
                                    this.props.dynamicFormActions.fetchFormErrorResponseSuccess(payload);
                                }
                            };
                            const successCallBack = (data) => {
                                this.props.dynamicFormActions.submitClicked(false);
                                this.props.dynamicFormActions.apiRunningStatus(false);
                                window["AppInsightTrace"].trackTrace(`on submit form click successCallBack`);
                                ReactGA.event({
                                    category: "Submit Form",
                                    action: `Submit Form: ${data.id}`,
                                    label: `Submit Form: ${data.id} : ${dateTimeFormatter(data.saveTime)}`,
                                });
                                handleSubmitError(data);
                            };
                            const failureCallback = (data) => {
                                let commonErrorMsg = "";
                                const validationMessage = (data.errors && data.errors.validationMessage) || "";
                                if (validationMessage) {
                                    handleSubmitError(data);
                                } else if (data && data.response && data.response.data && data.response.data.Message) {
                                    commonErrorMsg = data.response.data.Message;
                                    window["AppInsightTrace"].trackException(
                                        `on submit form click Failure: ${commonErrorMsg} `
                                    );
                                } else {
                                    const globalErrorMsg = this.props.globalErrorActions.showGlobalError(
                                        (data && data.response && data.response.data) || ""
                                    );
                                    commonErrorMsg = globalErrorMsg.payload.errorMessage;
                                    window["AppInsightTrace"].trackException(
                                        `on submit form click global Failure: ${commonErrorMsg}`
                                    );
                                }
                                ReactGA.event({
                                    category: "Error",
                                    action: `Error: ${commonErrorMsg}`,
                                    label: `Error: ${commonErrorMsg}`,
                                });
                                this.props.dynamicFormActions.submitClicked(false);
                                this.props.dynamicFormActions.apiRunningStatus(false);
                            };
                            setTimeout(() => {
                                const payload = {
                                    payload: {
                                        Id: warrantyId,
                                        formData: warrantyInfo,
                                        WaiverReceived: waiverReceived,
                                        successCallBack: successCallBack,
                                        failureCallback: failureCallback,
                                    },
                                };
                                submitWarranty(payload);
                            }, 1000);
                        } else if (
                            x &&
                            x.data &&
                            !x.data.isPriceChanged &&
                            this.props.clickDetails &&
                            this.props.clickDetails.clickId
                        ) {
                            this.props.dynamicFormActions.apiRunningStatus(false);
                            if (document.getElementById(this.props.clickDetails.clickId))
                                document.getElementById(this.props.clickDetails.clickId).click();
                        } else {
                            this.setState({
                                previousValue: userInput,
                            });
                            this.props.dynamicFormActions.apiRunningStatus(false);
                            this.props.onChange(this.state.dateValue);
                        }
                    } else if (
                        !e.target.value &&
                        !e.target.value !== this.state.previousValue &&
                        priceCheck &&
                        priceCheck.length > 0 &&
                        checkForPriceChanges(schema.const, isSubmittedForm)
                    ) {
                        this.props.dynamicFormActions.apiRunningStatus(false);
                        this.setState(
                            {
                                date: this.state.previousValue,
                                dateValue: this.state.previousValue,
                                error: { error: false, errorMessage: [] },
                            },
                            () => {
                                this.props.onChange(dateFormatter(this.state.previousValue));
                                this.props.getValues && this.props.getValues(this.state);
                            }
                        );
                    }
                } else {
                    this.setState(
                        {
                            date: "",
                            // dateValue: this.state.todaysDate,
                        },
                        () => {
                            this.props.onChange(dateFormatter(this.state.dateValue));
                            this.props.getValues && this.props.getValues(this.state);
                        }
                    );
                }
            }
        } else {
            const validationError = validationCheck(userInput, fieldName, family, errorSchema);
            this.setState(
                {
                    date: this.state.date || e.target.value,
                    dateValue: this.state.dateValue || "",
                    error: validationError && validationError.error
                        ? validationCheck(this.state.dateValue || "", fieldName, family, errorSchema)
                        : this.state.error,
                },
                () => {
                    this.props.onChange(this.state.dateValue);
                    this.props.getValues && this.props.getValues(this.state);
                }
            );
        }
    }

    customDateFormatter(date) {
        const d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
        const format = (value) => (value.length < 2 ? "0" + value : value);
        return [format(month), format(day), year].join("");
    }

    fieldClicked = () => {
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        removeFieldIdFromStore(this.props.id);
    };
    handleEnter = (e) => {
        if (e.keyCode === 13) {
            this.calendarToggle();
        } else if (e.keyCode == 9 || e.keyCode == 27) {
            this.setState({
                openCalendar: false,
            });
        }
    };
    render() {
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const { schema, id, isSubmittedForm, errorDetails } = this.props;
        const { error } = this.state;
        let disableMinDate = schema.const.currentDate ? new Date(schema.const.currentDate) : new Date();
        const disableMaxDate = schema.const.currentDate ? new Date(schema.const.currentDate) : new Date();
        this.adminChecks()
            ? (disableMinDate = null)
            : schema.const.fromDate
            ? disableMinDate.setDate(disableMinDate.getDate() - parseInt(schema.const.fromDate))
            : disableMinDate.setDate(disableMinDate.getDate() - 90);
        schema.const.toDate
            ? disableMaxDate.setDate(disableMaxDate.getDate() + parseInt(schema.const.toDate))
            : disableMaxDate.setDate(disableMaxDate.getDate());
        return (
            <div className="calendar-container">
                <Label schema={schema} />
                <div onFocus={checkForReadOnly(schema.const, isSubmittedForm) ? () => {} : this.fieldClicked}>
                    <div className="input-container input-container-form" onKeyDown={this.handleEnter}>
                        <MaskedInput
                            id={id}
                            type="text"
                            placeholder={schema.const.placeholder}
                            tabIndex={schema.const.tabIndex}
                            onKeyPress={handleEnter}
                            className={
                                (this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0) ||
                                (this.props.errorDetails[id] && this.props.errorDetails[id].length > 0)
                                    ? "date-textbox error-boundry"
                                    : "date-textbox"
                            }
                            mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
                            value={
                                this.state.dateValue.length !== 10
                                    ? this.customDateFormatter(this.state.dateValue)
                                    : dateFormatter(this.state.dateValue)
                            }
                            onChange={this.inputBoxChange}
                            onClick={checkForReadOnly(schema.const, isSubmittedForm) ? () => {} : this.calendarToggle}
                            onBlur={this.blurCheck}
                            disabled={checkForReadOnly(schema.const, isSubmittedForm)}
                        />
                        <img
                            src={`${getimagePath}calendar.png`}
                            className="calendar-icon"
                            onClick={checkForReadOnly(schema.const, isSubmittedForm) ? () => {} : this.calendarToggle}
                        />
                    </div>
                    {this.state.openCalendar && (
                        <div className="calender-main-container">
                            <div className="date-header">
                                <div className="date-year">{new Date(this.state.dateValue).getFullYear()}</div>
                                <div className="date-day">{this.dateFormatter(this.state.dateValue)}</div>
                            </div>
                            <Calendar
                                onChange={this.onChange}
                                value={
                                    !isNaN(new Date(this.state.dateValue).getTime())
                                        ? new Date(this.state.dateValue)
                                        : new Date(this.state.todaysDate)
                                }
                                minDate={disableMinDate}
                                // maxDate={disableMaxDate}
                                prevLabel={<img src={`${getimagePath}chevron-left-1.svg`}></img>}
                                nextLabel={<img src={`${getimagePath}chevron-right-1.svg`}></img>}
                            />
                        </div>
                    )}
                </div>
                <ErrorMessage errorDetails={errorDetails} errorState={error} propId={id} />
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        warrantyInfo: state.dynamicFormInfo.warrantyInfo,
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        isSubmittedForm: state.adminData.isSubmittedForm,
        warrantyId: state.dynamicFormInfo.warrantyId,
        userInfo: state.adminData.userInfo,
        isSubmitClicked: state.dynamicFormInfo.isSubmitClicked,
        clickDetails: state.dynamicFormInfo.clickDetails,
        waiverReceived: state.adminData.waiverReceived,
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalErrorActions: bindActionCreators(globalErrorActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(onClickOutside(DatePickerWidget));
